import { AnimatePresence } from 'framer-motion'
import React, { useContext } from 'react'
import { Selected } from '../../../../context/context'
import {
    Content,
    Title,
    OptionsContainer,
    Option,
} from './Elements'
import {
    titleMotion,
    optionsContainerMotion,
    optionMotion
} from './Motion'

const Cantidades = ({ setSteps }) => {

    const [selected, setSelected] = useContext(Selected)
    const options = [
        {
            n: '10-20 prendas',
            value: 'A'
        },
        {
            n: '21-50 prendas',
            value: 'B'
        },
        {
            n: '51-100 prendas',
            value: 'C'
        },
        {
            n: '101-200 prendas',
            value: 'D'
        },
    ]

    const handleClick = (option) => {

        setSelected({...selected, cantidad: option})
        setSteps(2)
    }

    return(
        <Content>
            <Title
            variants={titleMotion}
            initial='initial'
            animate='animate'
            exit='exit'
            >
                Elegí una cantidad
            </Title>
            <OptionsContainer
            variants={optionsContainerMotion}
            initial='initial'
            animate='animate'
            exit='exit'
            >
                <AnimatePresence>
                    
                {
                    options.map(option => {
                        return(
                            <Option
                            key={option.value}
                            variants={optionMotion}
                            onClick={() => handleClick(option.value)}
                            >
                                {option.n}
                            </Option>
                        )
                    })
                }
                </AnimatePresence>
            </OptionsContainer>
        </Content>
    )
}

export default Cantidades